import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import MyStreamWaveMyVoteVotes from "./MyStreamWaveMyVoteVotes";
import MyStreamWaveMyVoteInput from "./MyStreamWaveMyVoteInput";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import { SingleWaveDropPosition } from "@/components/waves/drop/SingleWaveDropPosition";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import Link from "next/link";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { ImageScale } from "@/helpers/image.helpers";
import { Tooltip } from "react-tooltip";
interface MyStreamWaveMyVoteProps {
  readonly drop: ExtendedDrop;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly isChecked?: boolean | undefined;
  readonly onToggleCheck?: ((dropId: string) => void) | undefined;
  readonly isResetting?: boolean | undefined;
}
const MyStreamWaveMyVote: React.FC<MyStreamWaveMyVoteProps> = t0 => {
  const $ = _c(83);
  const {
    drop,
    onDropClick,
    isChecked: t1,
    onToggleCheck,
    isResetting: t2
  } = t0;
  const isChecked = t1 === undefined ? false : t1;
  const isResetting = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== drop.parts) {
    t3 = drop.parts.at(0)?.media.at(0);
    $[0] = drop.parts;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const artWork = t3;
  let t4;
  if ($[2] !== drop || $[3] !== onDropClick) {
    t4 = () => {
      if (window.getSelection()?.toString()) {
        return;
      }
      onDropClick(drop);
    };
    $[2] = drop;
    $[3] = onDropClick;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleClick = t4;
  let t5;
  if ($[5] !== drop.id || $[6] !== onToggleCheck) {
    t5 = e => {
      e.stopPropagation();
      if (onToggleCheck) {
        onToggleCheck(drop.id);
      }
    };
    $[5] = drop.id;
    $[6] = onToggleCheck;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  const handleCheckboxClick = t5;
  const t6 = drop.id;
  const t7 = `tw-bg-iron-950 tw-rounded-xl tw-px-5 tw-py-4 tw-border tw-border-solid tw-transition-all tw-duration-300 tw-cursor-pointer tw-shadow-md desktop-hover:hover:tw-shadow-lg tw-@container ${isChecked ? "tw-border-primary-400" : "tw-border-iron-800 desktop-hover:hover:tw-border-iron-700"}`;
  const t8 = `tw-size-5 tw-flex tw-items-center tw-justify-center tw-rounded-md tw-border tw-border-solid ${isChecked ? "tw-border-primary-400 tw-bg-primary-400/20" : "tw-border-iron-600 tw-bg-iron-800"} tw-cursor-pointer tw-shadow-sm hover:tw-shadow-md tw-transition-all tw-duration-200`;
  let t9;
  if ($[8] !== isChecked) {
    t9 = isChecked && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className="tw-size-4 tw-text-primary-400"><path fillRule="evenodd" d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 0 1 1.04-.208Z" clipRule="evenodd" /></svg>;
    $[8] = isChecked;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t8 || $[11] !== t9) {
    t10 = <div className={t8}>{t9}</div>;
    $[10] = t8;
    $[11] = t9;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== handleCheckboxClick || $[14] !== t10) {
    t11 = <div className="tw-flex-shrink-0 tw-self-start tw-mr-1" onClick={handleCheckboxClick}>{t10}</div>;
    $[13] = handleCheckboxClick;
    $[14] = t10;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== artWork) {
    t12 = artWork && <DropListItemContentMedia media_mime_type={artWork.mime_type} media_url={artWork.url} imageScale={ImageScale.AUTOx450} isCompetitionDrop={true} />;
    $[16] = artWork;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12) {
    t13 = <div className="tw-flex-shrink-0 tw-overflow-hidden tw-bg-iron-800 tw-min-h-[106px] tw-min-w-[106px] @md:tw-size-[106px] @xs:tw-w-full @xs:tw-h-56 @sm:tw-w-full @sm:tw-h-56 @sm:tw-mb-2 tw-relative"><div className="tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center tw-relative desktop-hover:hover:tw-scale-105 tw-transform tw-duration-300 tw-ease-out"><div className="tw-absolute tw-inset-0 tw-z-[1]">{t12}</div></div></div>;
    $[18] = t12;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== drop.title) {
    t14 = <h3 className="tw-text-base tw-font-semibold tw-text-iron-50 tw-mb-0">{drop.title}</h3>;
    $[20] = drop.title;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== drop.rank) {
    t15 = drop.rank && <SingleWaveDropPosition rank={drop.rank} />;
    $[22] = drop.rank;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t14 || $[25] !== t15) {
    t16 = <div className="tw-flex tw-items-center tw-justify-between tw-gap-x-3">{t14}{t15}</div>;
    $[24] = t14;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== drop.author.pfp) {
    t17 = <div className="tw-size-6 tw-relative tw-flex-shrink-0 tw-rounded-md tw-overflow-hidden tw-ring-1 tw-ring-white/10 tw-bg-iron-800">{drop.author.pfp ? <img src={drop.author.pfp} alt="Profile" className="tw-h-full tw-w-full tw-object-contain tw-bg-iron-800" /> : <div className="tw-h-full tw-w-full tw-bg-iron-800 tw-rounded-md tw-ring-1 tw-ring-white/10" />}</div>;
    $[27] = drop.author.pfp;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  const t18 = drop.author.level || 0;
  let t19;
  if ($[29] !== t18) {
    t19 = <UserCICAndLevel level={t18} size={UserCICAndLevelSize.SMALL} />;
    $[29] = t18;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  const t20 = drop.author.handle ?? drop.author.id;
  const t21 = `/${drop.author.handle}`;
  let t22;
  if ($[31] !== drop.author.handle) {
    t22 = e_0 => {
      e_0.stopPropagation();
      e_0.preventDefault();
      window.open(`/${drop.author.handle}`, "_blank");
    };
    $[31] = drop.author.handle;
    $[32] = t22;
  } else {
    t22 = $[32];
  }
  let t23;
  if ($[33] !== drop.author.handle || $[34] !== t21 || $[35] !== t22) {
    t23 = <Link href={t21} onClick={t22} className="tw-text-md tw-text-iron-200 desktop-hover:hover:tw-text-opacity-80 tw-transition-colors tw-duration-200 tw-no-underline desktop-hover:hover:tw-underline tw-font-medium tw-truncate">{drop.author.handle}</Link>;
    $[33] = drop.author.handle;
    $[34] = t21;
    $[35] = t22;
    $[36] = t23;
  } else {
    t23 = $[36];
  }
  let t24;
  if ($[37] !== t20 || $[38] !== t23) {
    t24 = <UserProfileTooltipWrapper user={t20}>{t23}</UserProfileTooltipWrapper>;
    $[37] = t20;
    $[38] = t23;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] !== t17 || $[41] !== t19 || $[42] !== t24) {
    t25 = <div className="tw-flex tw-items-center tw-gap-2 tw-mt-4">{t17}{t19}{t24}</div>;
    $[40] = t17;
    $[41] = t19;
    $[42] = t24;
    $[43] = t25;
  } else {
    t25 = $[43];
  }
  let t26;
  if ($[44] !== drop) {
    t26 = <div onClick={_temp}><MyStreamWaveMyVoteVotes drop={drop} /></div>;
    $[44] = drop;
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] !== drop.id || $[47] !== drop.top_raters) {
    t27 = drop.top_raters?.slice(0, 3).map(voter => <React.Fragment key={voter.profile.handle}><Link href={`/${voter.profile.handle}`} onClick={_temp2} data-tooltip-id={`my-vote-voter-${drop.id}-${voter.profile.handle}`}>{voter.profile.pfp ? <img className="tw-w-6 tw-h-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800 tw-object-contain" src={voter.profile.pfp} alt="Recent voter" /> : <div className="tw-w-6 tw-h-6 tw-rounded-md tw-border-2 tw-border-solid tw-border-[#111] tw-bg-iron-800" />}</Link><Tooltip id={`my-vote-voter-${drop.id}-${voter.profile.handle}`} place="top" offset={8} opacity={1} style={{
        padding: "4px 8px",
        background: "#37373E",
        color: "white",
        fontSize: "13px",
        fontWeight: 500,
        borderRadius: "6px",
        boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
        zIndex: 99999,
        pointerEvents: "none"
      }}>{voter.profile.handle} -{" "}{formatNumberWithCommas(voter.rating)}</Tooltip></React.Fragment>);
    $[46] = drop.id;
    $[47] = drop.top_raters;
    $[48] = t27;
  } else {
    t27 = $[48];
  }
  let t28;
  if ($[49] !== t27) {
    t28 = <div className="tw-flex tw-items-center -tw-space-x-2">{t27}</div>;
    $[49] = t27;
    $[50] = t28;
  } else {
    t28 = $[50];
  }
  let t29;
  if ($[51] !== drop.raters_count) {
    t29 = formatNumberWithCommas(drop.raters_count);
    $[51] = drop.raters_count;
    $[52] = t29;
  } else {
    t29 = $[52];
  }
  const t30 = drop.raters_count === 1 ? "voter" : "voters";
  let t31;
  if ($[53] !== t30) {
    t31 = <span className="tw-text-iron-500 tw-font-normal">{t30}</span>;
    $[53] = t30;
    $[54] = t31;
  } else {
    t31 = $[54];
  }
  let t32;
  if ($[55] !== t29 || $[56] !== t31) {
    t32 = <span className="tw-text-iron-200 tw-font-semibold tw-text-sm">{t29}{" "}{t31}</span>;
    $[55] = t29;
    $[56] = t31;
    $[57] = t32;
  } else {
    t32 = $[57];
  }
  let t33;
  if ($[58] !== t28 || $[59] !== t32) {
    t33 = <div className="tw-flex tw-items-center tw-gap-2">{t28}{t32}</div>;
    $[58] = t28;
    $[59] = t32;
    $[60] = t33;
  } else {
    t33 = $[60];
  }
  let t34;
  if ($[61] !== t26 || $[62] !== t33) {
    t34 = <div className="tw-flex tw-items-center tw-gap-x-6">{t26}{t33}</div>;
    $[61] = t26;
    $[62] = t33;
    $[63] = t34;
  } else {
    t34 = $[63];
  }
  let t35;
  if ($[64] !== drop || $[65] !== isResetting) {
    t35 = <div onClick={_temp3}><MyStreamWaveMyVoteInput drop={drop} isResetting={isResetting} /></div>;
    $[64] = drop;
    $[65] = isResetting;
    $[66] = t35;
  } else {
    t35 = $[66];
  }
  let t36;
  if ($[67] !== t34 || $[68] !== t35) {
    t36 = <div className="tw-flex tw-flex-col @lg:tw-flex-col @[42rem]:tw-flex-row tw-justify-between tw-gap-4 tw-mt-3.5 xl:tw-mt-3">{t34}{t35}</div>;
    $[67] = t34;
    $[68] = t35;
    $[69] = t36;
  } else {
    t36 = $[69];
  }
  let t37;
  if ($[70] !== t16 || $[71] !== t25 || $[72] !== t36) {
    t37 = <div className="tw-flex tw-flex-col tw-flex-1 tw-min-w-0">{t16}{t25}{t36}</div>;
    $[70] = t16;
    $[71] = t25;
    $[72] = t36;
    $[73] = t37;
  } else {
    t37 = $[73];
  }
  let t38;
  if ($[74] !== t11 || $[75] !== t13 || $[76] !== t37) {
    t38 = <div className="tw-flex @md:tw-flex-row @sm:tw-flex-col @xs:tw-flex-col tw-gap-4">{t11}{t13}{t37}</div>;
    $[74] = t11;
    $[75] = t13;
    $[76] = t37;
    $[77] = t38;
  } else {
    t38 = $[77];
  }
  let t39;
  if ($[78] !== drop.id || $[79] !== handleClick || $[80] !== t38 || $[81] !== t7) {
    t39 = <div key={t6} className={t7} onClick={handleClick}>{t38}</div>;
    $[78] = drop.id;
    $[79] = handleClick;
    $[80] = t38;
    $[81] = t7;
    $[82] = t39;
  } else {
    t39 = $[82];
  }
  return t39;
};
export default MyStreamWaveMyVote;
function _temp(e_1) {
  return e_1.stopPropagation();
}
function _temp2(e_2) {
  return e_2.stopPropagation();
}
function _temp3(e_3) {
  return e_3.stopPropagation();
}